import React from "react";
import styles from './ModalBox.module.scss';
import Styles from "../../Dashboard/Pages/UserManagement/Actions.module.scss";
import Button from "../mainButton/Button";

const ModalBox = ({ fixedSize, size = 'large', showModal = false, title = 'Modal Box Title', dialogTitle, handleTriggerShowModal, handleOnPrevious, children, type, onSubmit, onCancel, submitText, cancelText }) => {

  return (
    <div className={[styles.ModalBoxWrapper, (showModal ? styles.show : styles.hide)].join(' ')}>
      <div style={{width: fixedSize && fixedSize}} className={styles.box}>
        <div style={{width: fixedSize && "100%", padding: fixedSize && 24}} className={[styles.modalBox, type === "dialog" && styles.dialog, styles[size]].join(' ')}>
          <div>
            <span className={styles.title}>
              {
                handleOnPrevious && <i onClick={handleOnPrevious}>
                  <svg width="20" height="24" viewBox="0 0 20 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9.00721 12.2512L16.1411 12.2512" stroke="#0A195C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.00732 7.25024L2.68087 12.2512L9.00732 17.2522L9.00732 7.25024Z" stroke="#0A195C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </i>
              }
              <span>{ title }</span>
            </span>
            <span className={styles.close} onClick={handleTriggerShowModal}>
              <i>
                <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <line x1="14.8701" y1="1.06066" x2="1.93078" y2="14" stroke="#060F36" stroke-width="1.5" stroke-linecap="round"/>
                  <path d="M1.80347 0.933341L14.8135 13.9434" stroke="#060F36" stroke-width="1.5" stroke-linecap="round"/>
                </svg>
              </i>
            </span>
          </div>
          {
            type === "dialog" ?
              <>
                <div className={styles.dialogTitle}>
                  {dialogTitle}
                </div>
                <>
                  { children }
                </>
                <div className={'d-flex justify-content-between mt-3'}>
                  <div className={'d-flex flex-grow-1'}>
                    <Button block type={"contained"} color={"primary"} size={"medium"} onClick={onSubmit}>{submitText}</Button>
                  </div>
                  <div className={'d-flex flex-grow-1 ml-3'}>
                    <Button block type={"outlined"} color={"primary"} size={"medium"} onClick={onCancel}>{cancelText}</Button>
                  </div>
                </div>
              </> :
              <div>
                { children }
              </div>
          }
        </div>
      </div>
    </div>
  )
};

export default ModalBox;